/*
 * A busca: o menu de busca (SearchMenu) no lugar do botão que
 * abria o SearchModal do core. O do cabeçalho é desenhado pelo HeaderSearch
 * (shell/); aqui entra o do banner de boas-vindas, que é o mesmo
 * `search-menu`.
 */
import { extend } from 'flarum/common/extend';
import WelcomeBanner from '../list/WelcomeBanner';
import SearchMenu from './SearchMenu';
export { default as SearchMenu } from './SearchMenu';
export default function installSearchMenu() {
  extend(WelcomeBanner.prototype, 'bodyItems', function (items) {
    if (!items.has('search')) return;
    items.setContent('search', m("div", {
      className: "CanelaWelcome-search"
    }, m(SearchMenu, {
      location: "welcome"
    })));
  });
}
flarum.reg.add('ramon-canela', 'forum/search', installSearchMenu);